import { ConfigurablePropsFromDescription } from "../../../helpers/widget"
import PublishUtils from "../../../helpers/PublishUtils"

export const configOptions = [
  {
    name: 'ifcUrls',
    type: 'text',
    label: 'IFC URLs to load and view (not the UploadAnyFile URI)',
    topicValueInterpolationEnabled: true
  },
  PublishUtils.getMultipleValueFormatOptions()
] as const

export type IFCViewerV4ConfigOptions = ConfigurablePropsFromDescription<typeof configOptions>